import { upsellCardDefaultText } from "@redotech/order-tracking-common/tracking-page-defaults";
import { DiscountValueType } from "@redotech/redo-discounts-common/discount";
import {
  DiscountSettings,
  DiscountSettingsType,
} from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { t } from "@redotech/redo-i18n";
import { validDiscount } from "./discount-util";

/**
 * Get upsell text based on custom text or discount information
 */
export function getUpsellText(
  upsellText: string | undefined,
  discountSettings: DiscountSettings | undefined,
): string {
  if (upsellText && upsellText !== upsellCardDefaultText) {
    return upsellText;
  }

  if (
    discountSettings &&
    discountSettings.settingsType === DiscountSettingsType.BASIC &&
    validDiscount(discountSettings)
  ) {
    return discountSettings.discountValueType === DiscountValueType.PERCENTAGE
      ? t("Shop again, get {{amount}}% off", {
          amount: discountSettings.discountValueAmount,
        })
      : t("Shop again, get ${{amount}} off", {
          amount: discountSettings.discountValueAmount,
        });
  }

  return upsellCardDefaultText;
}

/**
 * Calculate initial expiration duration for discount countdown
 */
export function getInitialExpirationDuration(
  discountSettings: DiscountSettings | undefined,
): number | undefined {
  if (!discountSettings) {
    return undefined;
  }

  const settings = discountSettings;
  if (!settings) {
    return undefined;
  }

  if (settings.endsAt) {
    const endDate = Temporal.Instant.from(settings.endsAt.toISOString());
    const futureInstant = Temporal.Instant.from(endDate);
    const durationUntilFutureInMs = Temporal.Now.instant()
      .until(futureInstant)
      .total({ unit: "milliseconds" });

    return durationUntilFutureInMs > 0 ? durationUntilFutureInMs : undefined;
  }
  return undefined;
}
